var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleWavyStar(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.808 25.192c-1.15-1.15-.388-3.566-.973-4.98C5.228 18.743 3 17.562 3 16c0-1.563 2.228-2.744 2.835-4.211.585-1.415-.178-3.83.973-4.981 1.15-1.15 3.566-.388 4.98-.973C13.257 5.228 14.438 3 16 3c1.563 0 2.744 2.228 4.211 2.835 1.416.585 3.83-.178 4.981.973 1.15 1.15.388 3.566.973 4.98C26.773 13.257 29 14.438 29 16c0 1.563-2.228 2.744-2.835 4.211-.585 1.416.178 3.83-.973 4.981-1.15 1.15-3.566.388-4.98.973C18.743 26.773 17.562 29 16 29c-1.563 0-2.744-2.228-4.211-2.835-1.415-.585-3.83.178-4.981-.973z",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11l1.41 3.489 3.59.33-2.72 2.488.81 3.693L16 19.049 12.91 21l.81-3.693L11 14.82l3.59-.331L16 11z",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgCircleWavyStar;